import { IPromise } from "angular";
import { ChangeJournalEntry } from "../changeJournalViewComponent/models";

export const vsServiceName = "changeJournalModalService";

export class ChangeJournalModalService {
  static $inject = ["$uibModal"];

  constructor(private readonly $uibModal: angular.ui.bootstrap.IModalService) {}

  getChangeJournalNote(): IPromise<ChangeJournalEntry> {
    return this.$uibModal.open({
      template: require("!html-loader!./modal.html").default,
    }).result;
  }

  getAndSetChangeJournalNote(model: any): IPromise<ChangeJournalEntry> {
    return this.getChangeJournalNote().then((note) => {
      this.setChangeJournalEntry(model, note);
      return model;
    });
  }

  setChangeJournalEntry(model: any, changeJournalEntry: ChangeJournalEntry) {
    model.ChangeJournalEntry = changeJournalEntry;
  }
}
